import { createSlice } from "@reduxjs/toolkit";
import { ServicesAPI } from "../../services/services";

const Services = createSlice({
  name: "Services",
  initialState: {
    services: [],
    oneService: null,
    total: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(ServicesAPI.getAll.fulfilled, (state, action) => {
        const { total, services } = action.payload;
        state.services = services;
        state.total = total;
      })

      .addCase(ServicesAPI.getOne.fulfilled, (state, action) => {
        state.oneService = action.payload;
      });
  },
});

export default Services;
